export default "__VITE_ASSET__qWgnfwVQ__"